import { Partner } from './partner.model';
import { SalesRepresentative } from './salesRepresentative.model';
import { Step, StepKey } from './step.model';

export class Onboarding {
  partner: Partner;
  salesRepresentative: SalesRepresentative;
  steps: Step[];

  constructor(
    partner: Partner = new Partner(),
    steps: Step[] = [],
    salesRepresentative: SalesRepresentative = new SalesRepresentative()
  ) {
    this.partner = partner;
    this.steps = steps;
    this.salesRepresentative = salesRepresentative;
  }

  get initialOnboardingStep(): StepKey {
    if (this.areAllStepsPending) return 'Greetings';
    if (this.areAllStepsCompleted) return 'Completed';

    return this.unlockedSteps[this.unlockedSteps.length - 1];
  }

  get areDocumentsSigned(): boolean {
    const signDocumentsStep = this.steps.find((step) => step.key === StepKey.SignDocuments);
    if (!signDocumentsStep) {
      return false;
    }

    return signDocumentsStep.isStepCompleted;
  }

  getNextAvailableStep(stepKey: StepKey): StepKey {
    if (!stepKey) return 'Greetings';

    if (stepKey === 'Greetings') {
      const firstStep = this.steps.find((step) => step.order === 0);
      if (!firstStep) return 'Greetings';

      return firstStep.key;
    }

    const step = this.getOnboardingStepByKey(stepKey);
    if (!step) return 'Greetings';

    if (step.isStepBlocked) return step.key;

    const nextStep = this.steps[step.order + 1];
    if (!nextStep && this.areAllStepsCompleted) return 'Completed';

    return nextStep.key;
  }

  getPreviousAvailableStep(stepKey: StepKey): StepKey {
    if (stepKey === 'Greetings') return 'Greetings';

    const step = this.getOnboardingStepByKey(stepKey);
    if (!step) return 'Greetings';

    const previousStep = this.steps[step.order - 1];
    if (!previousStep) return 'Greetings';

    return previousStep.key;
  }

  get unlockedSteps(): Step['key'][] {
    const steps: Step['key'][] = [];

    for (const step of this.steps) {
      steps.push(step.key);

      if (step.isStepPending || step.isStepBlocked) {
        break;
      }
    }

    return steps;
  }

  getOnboardingStepByKey(stepKey: StepKey): Step | null {
    const step = this.steps.find((step) => stepKey === step.key);
    if (!step) return null;

    return step;
  }

  private get areAllStepsPending(): boolean {
    return this.steps.every((step) => step.isStepPending);
  }

  private get areAllStepsCompleted(): boolean {
    return this.steps.every((step) => step.isStepCompleted);
  }
}
